module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Da-Ea.3b3cc30c.png";